var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "kanban-card",
      class: {
        "hovered-card": _vm.isHovered,
        "selected-card": _vm.isSelected,
      },
      style: _vm.cardStyle(),
      attrs: {
        "data-id": _vm.record._id,
        "data-index": _vm.recordIndex,
        "data-column-id": _vm.columnId,
        "data-column-index": _vm.columnIndex,
      },
      on: {
        click: _vm.onCardClick,
        mouseover: function ($event) {
          return _vm.$emit("hover", _vm.record._id)
        },
        mouseleave: function ($event) {
          return _vm.$emit("hover", null)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "card-selection-checkbox",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.$emit("toggle-selection", _vm.record._id)
            },
          },
        },
        [
          _vm.isSelected
            ? _c("i", { staticClass: "material-icons" }, [
                _vm._v("check_circle"),
              ])
            : _c("i", { staticClass: "material-icons" }, [
                _vm._v("radio_button_unchecked"),
              ]),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.cardFields, function (fld, idx) {
        return _c(
          "div",
          { key: idx, staticClass: "kanban-card-field" },
          [
            _vm.getFieldObject(fld)
              ? _c("i", { staticClass: "material-icons" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getFieldIcon(_vm.getFieldObject(fld))) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("label", [_vm._v(_vm._s(_vm.getFieldName(fld)) + ":")]),
            _vm._v(" "),
            _vm.getFieldObject(fld) &&
            _vm.getFieldObject(fld).fieldType === "linked-record"
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "linked-record-cell",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.viewLinkedRecord(_vm.record.data[fld], fld)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("switch_access_shortcut"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "linked-record-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getLinkedRecordLabel(
                              _vm.record.data[fld],
                              _vm.getFieldObject(fld)
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ]
              : _vm.getFieldObject(fld) &&
                _vm.getFieldObject(fld).fieldType === "contact"
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "linked-record-cell",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.viewContact(_vm.record.data[fld])
                        },
                      },
                    },
                    [
                      _vm.record.data[fld]
                        ? _c("PlatformIconViewer", {
                            attrs: { platform: _vm.record.data[fld].platform },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "linked-record-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$_.get(
                              _vm.record.data[fld],
                              "fullname",
                              "İsimsiz Kişi"
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              : _vm.getFieldObject(fld) &&
                _vm.getFieldObject(fld).fieldType === "user"
              ? [
                  _c(
                    "div",
                    { staticClass: "linked-record-cell" },
                    [
                      _vm.getUserInfo(_vm.record.data[fld])
                        ? _c("AgentAvatar", {
                            attrs: { userID: _vm.record.data[fld], size: 24 },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "linked-record-label" }, [
                        _vm._v(_vm._s(_vm.getUserLabel(_vm.record.data[fld]))),
                      ]),
                    ],
                    1
                  ),
                ]
              : _vm.getFieldObject(fld) &&
                _vm.getFieldObject(fld).fieldType === "task"
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "linked-record-cell",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.viewTask(_vm.record.data[fld])
                        },
                      },
                    },
                    [
                      _c("FieldIcon", {
                        attrs: {
                          type: "task",
                          size: 16,
                          "default-icon": _vm.getFieldObject(fld).icon,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "linked-record-label" }, [
                        _vm._v(_vm._s(_vm.getTaskLabel(_vm.record.data[fld]))),
                      ]),
                    ],
                    1
                  ),
                ]
              : _vm.getFieldObject(fld) &&
                _vm.getFieldObject(fld).fieldType !== "dropdown"
              ? [
                  _c("span", [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.getFormattedValue(
                            _vm.getFieldObject(fld),
                            _vm.record.data[fld]
                          )
                        ) +
                        "\n            "
                    ),
                  ]),
                ]
              : _vm.getFieldObject(fld) &&
                _vm.getFieldObject(fld).fieldType === "dropdown"
              ? [
                  _c(
                    "div",
                    { staticClass: "selected-options" },
                    _vm._l(
                      _vm.getArrayValue(_vm.record.data[fld]),
                      function (optionVal) {
                        return _c(
                          "div",
                          {
                            key: optionVal,
                            staticClass: "option-chip",
                            style: {
                              backgroundColor: _vm.getDropdownColor(
                                optionVal,
                                _vm.getFieldObject(fld)
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(optionVal) +
                                "\n                "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]
              : [_c("span", [_vm._v(_vm._s(_vm.record.data[fld]))])],
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }